import { render } from "./DocCard.vue?vue&type=template&id=96dc2ed8"
import script from "./DocCard.vue?vue&type=script&lang=ts"
export * from "./DocCard.vue?vue&type=script&lang=ts"
script.render = render

export default script